
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import VideoUModal from '@/components/video/VideoModal.vue';
import ShopService from '@/services/shop.service';

@Component({
  components: {
    VideoUModal,
  },
})
export default class SelectVideoModal extends Vue {
  visible = false;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  wordTitleArray!: any[];

  @Prop()
  formData!: any;

  @Prop()
  shopId!: string;

  @Ref('videoUModal')
  videoUModal!: VideoUModal;

  @Prop()
  headerVideo: any;

  listFormData = [];

  init(id: any) {
    this.visible = true;
    this.getList(id);
    if (this.headerVideo && this.headerVideo.length > 0) {
      this.selectedDatas = this.headerVideo.filter((x: any) => x !== null && typeof x === 'object');
      this.selectedKeys = this.headerVideo.map((item: any) => item?.resource_id).filter((item: any) => item !== undefined);
    } else {
      this.selectedKeys = [];
      this.selectedDatas = [];
    }
    // console.log(this.formData);
    this.listFormData = this.formData.video?.add || [];
    // console.log(this.listFormData);
  }

  async getList(data: any) {
    // console.log(data, 'lkllllllllllll');
    const params = {
      albumId: data,
      shopId: this.shopId,
    };
    // console.log(params, data);
    if (data) {
      const res = await this.shopService.albumShopOfficialInfo(params);
      // console.log(res);
      this.listData = res.list;
    } else {
      this.listData = [];
    }
  }

  handleOk() {
    // console.log(this.selectedDatas);
    const data = [...this.selectedDatas, ...new Array(1 - this.selectedDatas.length).fill(0)];
    this.visible = false;
    this.$emit('upload', data);
  }

  handleCancel() {
    this.visible = false;
  }

  playVideo(val: any) {
    // console.log('播放视频', val);
    this.videoUModal.open(val.path);
  }
  playOnly(event: any, item: any) {
    event.stopPropagation();
    event.preventDefault();
    this.playVideo(item);
  }

  callback(key: string) {
    // console.log(key, 'key');
    const res = this.wordTitleArray.find((item: any) => item.type === key);
    // console.log(res);
    this.getList(res);
  }

  listData = [];

  // 已选中的 key 数组
  selectedKeys: string[] = [];

  selectedDatas: any[] = [];
  handleCheck(key: string, data: any): void {
    // console.log(key, data, 'key');
    const index = this.selectedKeys.indexOf(key);
    if (index > -1) {
      // 已选中，取消
      this.selectedKeys.splice(index, 1);
      // this.selectedDatas.splice(index, 1);
      this.selectedDatas = this.selectedDatas.filter((item: any) => item.resource_id !== key);
    } else {
      // 未选中，加入
      if (this.selectedKeys.length >= 1) {
        return;
      }
      this.selectedKeys.push(key);
      this.selectedDatas[0] = data;
    }
    // console.log(this.selectedKeys);
  }
}
